import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { eswiUtils } from "@/tra/tancis/eswi/comn";
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import { APIS, URLS, SF_AUTH_SRCH, SG_SCRH_AUTH_LIST } from "@/tra/tancis/ptli/usr/extauth/services/PtliExtAuthService";

export const PTLI0924003Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptli0050", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const param = useParams();

    const { callback } = props;

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        authSrch: useForm({ defaultSchema: SF_AUTH_SRCH }),
    };

    /*
     * Declaration Grid
     * !== Grid 정의 ==!
     */
    const grid = {
        authList: useGrid({ defaultSchema: SG_SCRH_AUTH_LIST }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAuthList: useFetch({
            api: (page = grid.authList.page, size = grid.authList.size) =>
                APIS.getAuthList(form.authSrch.getValues(), page, size),
            enabled: true,
            key: [grid.authList.page, grid.authList.size],
            onSuccess: () => {},
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */

    const handler = {
        onBtnApplyClick: () => {
            if (grid.authList.getChecked().length === 0) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            if (callback) callback(grid.authList.getChecked());
        },
        onBtnSrchClick: () => fetch.getAuthList.fetch(),
    };

    const render = {};

    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Group.Row>
                            <Group.Control {...form.authSrch.schema.authId} />
                            <Group.Control {...form.authSrch.schema.authNm} />
                        </Group.Row>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onBtnSrchClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Grid {...grid.authList.grid} data={fetch.getAuthList.data?.authList} render={render} />

                        <Layout.Right>
                            <Button role={"apply"} onClick={handler.onBtnApplyClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
